// extracted by mini-css-extract-plugin
export default {"box_wrap":"Widgets_box_wrap__T5TOi"};